import { ConsentUpdateSource } from "../../video-sdk/core/message/constants";
import { useProviderTranscriptionConsentModal } from "./useProviderTranscriptionConsentModal";
import { ProviderTranscriptionConsentModalConnected as BaseProviderTranscriptionConsentModalConnected } from "@grow-therapy-team/seedling-components";

/**
 * Wrapper component that manages the modal display logic and connects the modal
 * to the orchestrating hook.
 */
export function ProviderTranscriptionConsentModalConnected() {
  const { isModalOpen, onClose, onDismiss, providerShortId } =
    useProviderTranscriptionConsentModal();

  if (!providerShortId) return null;

  return (
    <BaseProviderTranscriptionConsentModalConnected
      isOpen={isModalOpen}
      onClose={onClose}
      onDismiss={onDismiss}
      providerShortId={providerShortId}
      updateSource={ConsentUpdateSource.TELEHEALTH_WAITING_ROOM}
    />
  );
}
